import styled from "styled-components";

import FormContentBase from "/component/partial/FormContent";
import { layout } from "/styles";

export const FormContent = styled(FormContentBase)(layout.spacedChildrenVertical(40));
